import { Application } from '@hotwired/stimulus';

const stimulus = Application.start();

window.Stimulus = stimulus;
stimulus.debug = document.documentElement.classList.contains('debug');

export { stimulus };
